import { render } from "./MainCreditNoteShopping.vue?vue&type=template&id=1714058a&scoped=true"
import script from "./MainCreditNoteShopping.vue?vue&type=script&lang=js"
export * from "./MainCreditNoteShopping.vue?vue&type=script&lang=js"

import "./MainCreditNoteShopping.vue?vue&type=style&index=0&id=1714058a&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1714058a"]])

export default __exports__